<script setup lang="ts">
import { Form } from 'vee-validate'
import { formResetPasswordSchema } from '~/validate/forms/auth'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import { useResetPassword } from '~/composables/account/use-reset-password'
import BaseButton from '~/components/common/base-button.vue'
import PasswordIcon from '~/assets/images/icons/password-icon.svg'
import BaseInput from '~/components/common/base-input.vue'

const { passwordReset, handleSubmitResetPassword, resetError, isDisableFormReset } = useResetPassword()
const isButtonDisabled = (errors: object): boolean => isDisableFormReset.value || Object.values(errors).some(v => v)
</script>

<template>
  <Form
    v-slot="{ isSubmitting, errors }"
    name="form-reset-password"
    :validationSchema="formResetPasswordSchema"
    class="form"
    @submit="handleSubmitResetPassword"
  >
    <div class="form__title">Mật khẩu mới</div>
    <div class="form__sub-title">Vui lòng tạo mật khấu mới cho tài khoản của Quý khách</div>
    <div class="form__content">
      <BaseInput
        v-model="passwordReset.newPassword"
        type="password"
        name="newPassword"
        label="Mật khẩu"
        :maxLength="AUTH_CRITERIA.PASSWORD_MAX_LENGTH"
        className="required"
        :isLabelFloating="true"
        :iconPrepend="PasswordIcon"
        @input="resetError"
      />
      <BaseInput
        v-model="passwordReset.confirmPassword"
        type="password"
        name="passwordConfirm"
        label="Xác nhận mật khẩu"
        :maxLength="AUTH_CRITERIA.PASSWORD_MAX_LENGTH"
        className="required"
        :isLabelFloating="true"
        :iconPrepend="PasswordIcon"
        @input="resetError"
      />
    </div>
    <div class="form__btn-login mb-0">
      <BaseButton
        class="button"
        type="submit"
        :isLoadingButton="isSubmitting"
        :disable="isSubmitting || isButtonDisabled(errors)"
        size="extra-large"
      >
        Tạo mật khẩu mới
      </BaseButton>
    </div>
  </Form>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/auth/form-auth.scss';
</style>
